import { render, staticRenderFns } from "./GroupUpdateData.vue?vue&type=template&id=a0074e10&scoped=true"
import script from "./GroupUpdateData.vue?vue&type=script&lang=js"
export * from "./GroupUpdateData.vue?vue&type=script&lang=js"
import style0 from "./GroupUpdateData.vue?vue&type=style&index=0&id=a0074e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0074e10",
  null
  
)

export default component.exports